import { useI18n } from '#i18n'
import { parseISO, intlFormat } from 'date-fns'

export default function (): { formatToFullDate: (arg: string) => string } {
  const { locale, locales } = useI18n()

  const getLocaleISO = (code: string) => {
    const locale = locales.value.find((i) => i.code === code)
    return locale ? locale.iso : code
  }

  const formatToFullDate = (
    dateString: string,
    options = { year: 'numeric', month: 'long', day: 'numeric' }
  ): string | undefined => {
    if (!dateString) return undefined
    options = Object.fromEntries(
      Object.entries(options).filter(([_, v]) => v != null)
    )
    return capitalizeFirstLetter(
      intlFormat(parseISO(dateString), options, {
        locale: getLocaleISO(locale.value),
      }).toLowerCase()
    )
  }

  return {
    formatToFullDate,
  }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
